import { render } from "./ProposalNotAvailable.vue?vue&type=template&id=4cab2ad8&scoped=true"
import script from "./ProposalNotAvailable.vue?vue&type=script&lang=js"
export * from "./ProposalNotAvailable.vue?vue&type=script&lang=js"

import "./ProposalNotAvailable.vue?vue&type=style&index=0&id=4cab2ad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cab2ad8"]])

export default __exports__